import { SAVE_ALL_COURSES, INIT_SIGNOUT, SAVE_IN_PROGRES_COURSES, SAVE_OTHER_INPROGRESS_COURSES, UPDATE_USER_SURVEY_STATUS, SAVE_COURSEUPGRADE_DATA } from '../Actions/actionTypes';

const INIT_STATE = {
  allCourses: [],
  trialAndInProgress: {},
  otherInprogressCourses: [],
  courseUpgradeData: [],
};

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ALL_COURSES:
      return {
        ...state,
        allCourses: action.allCourses,
      };
    case SAVE_IN_PROGRES_COURSES:
      return {
        ...state,
        trialAndInProgress: action.trialAndInProgress,
      };
    case SAVE_OTHER_INPROGRESS_COURSES:
      return {
        ...state,
        otherInprogressCourses: action.otherInprogressCourses,
      };
    case UPDATE_USER_SURVEY_STATUS:
      let trialAndInProgressObject = state.trialAndInProgress;
      trialAndInProgressObject.surveyAnseredStatus = action.updatedSurveyAnseredStatus;
      return {
        ...state,
        trialAndInProgress: trialAndInProgressObject,
      };
    case SAVE_COURSEUPGRADE_DATA:
      return {
        ...state,
        courseUpgradeData: action.courseUpgradeData,
      };
    case INIT_SIGNOUT:
      return INIT_STATE;

    default:
      return state;
  }
};

export default Dashboard;
